<template>
  <div class="verified hvh-flex align-center font-sm no-line-height">
    <v-icon class="ml-1" color="white" small>mdi-checkbox-marked-circle</v-icon>
    <span class="ml-1">{{ cohortVerifiedHeading }}</span>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    cohortVerifiedHeading() {
      return `Clinically Verified Cohort by ${this.value.createdBy || this.value.creatorClient}`;
    },
  }
}
</script>

<style lang="scss" scoped>
.verified {
  background: linear-gradient(90deg, #666adf 0%, #5257d3 100%);
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 1px 1px 0 1px;
}
</style>